module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "file_036"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0020-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "file_036"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("The remains of the XF3F-1 rest in Pinelawn Cemetery on March 22, 1935, after the plane came apart in a dive experiment over Long Island. Grumman test pilot “Jimmy” Collins was killed in the crash. "), _c('em', [_vm._v("Grumman History Center")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f0cb92e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_036.vue
// module id = 159
// module chunks = 0